import { render, staticRenderFns } from "./Pagination.vue?vue&type=template&id=f254f698&scoped=true"
import script from "./Pagination.vue?vue&type=script&lang=js"
export * from "./Pagination.vue?vue&type=script&lang=js"
import style0 from "./Pagination.vue?vue&type=style&index=0&id=f254f698&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f254f698",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/prod-www.dijie360.com-nginx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f254f698')) {
      api.createRecord('f254f698', component.options)
    } else {
      api.reload('f254f698', component.options)
    }
    module.hot.accept("./Pagination.vue?vue&type=template&id=f254f698&scoped=true", function () {
      api.rerender('f254f698', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/common/Pagination.vue"
export default component.exports